import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=a006064e"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a006064e')) {
      api.createRecord('a006064e', component.options)
    } else {
      api.reload('a006064e', component.options)
    }
    module.hot.accept("./Default.vue?vue&type=template&id=a006064e", function () {
      api.rerender('a006064e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/layouts/Default.vue"
export default component.exports